import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, field } from '@simonbackx/simple-encoding';
import { Organization } from '../Organization.js';
import { RegistrationWithMemberBlob } from './RegistrationWithMemberBlob.js';
export class RegistrationsBlob extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.registrations = [];
        this.organizations = [];
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(RegistrationWithMemberBlob) })
], RegistrationsBlob.prototype, "registrations", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(Organization) })
], RegistrationsBlob.prototype, "organizations", void 0);
//# sourceMappingURL=RegistrationsBlob.js.map